export default __webpack_public_path__ + "static/media/token.bc99e0c8.png";